import { all, put, select, call, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import {
  apiCheckoutBuildPending,
  apiCheckoutLinePay,
  apiRequestLinePay,
} from '@dragonfruit/services/apis';
import { getAppsflyerFromCookie } from '@dragonfruit/utils/appsflyers';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { LINE_PAY_CONFIRM_WEBHOOk } from '@dragonfruit/constants/purchase';
import { HAS_SUBSCRIPTION_PLAN } from '@dragonfruit/constants/errorCode';
import { LINE_PAY } from '@dragonfruit/constants/paymentTypes';
import { getSelectedPlan, setHasSubscription } from '@dragonfruit/redux/plans';
import { savePurchase } from '@dragonfruit/redux/purchase/paymentReceipt';
import * as actions from '@dragonfruit/redux/purchase/checkoutLinePay';
import { getDiscountCode } from '@dragonfruit/redux/discountCode';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { paymentReceipt, home } from '@dragonfruit/redux/navigation';
import { getBundleContents } from '@dragonfruit/redux/plans';
import {
  sendInitialCheckoutEvents,
  sendSuccessCheckoutEvents,
} from './purchaseEvents';

export function* requestLinePay(action) {
  const {
    collectionId,
    paymentMethodId,
    invoiceInfo,
    deliveryInfo,
  } = action.payload;
  const discountCode = yield select(getDiscountCode);
  const bundleContents = yield select(getBundleContents);
  const appsflyerSale = getAppsflyerFromCookie();
  const selectedPlan = yield select(getSelectedPlan);
  const {
    planType,
    questionQuota,
    name,
    id,
    currency,
    paymentMethods,
    sellingTypes,
  } = selectedPlan;
  const { sku = '', price } = paymentMethods.find(
    ({ isSelected }) => isSelected
  );

  try {
    let commonData = {
      collectionId,
      paymentMethodId,
      deliveryInfo,
    };

    // if users use discount code
    if (discountCode) {
      commonData.code = discountCode;
    }

    if (bundleContents && bundleContents.length > 0) {
      commonData.bundleContents = bundleContents;
    }

    let buildPendingData = { ...commonData };
    if (appsflyerSale) {
      buildPendingData.appsflyerSale = appsflyerSale;
    }

    yield call(sendInitialCheckoutEvents, {
      planId: id,
      paymentMethodId: id,
      paymentType: LINE_PAY,
      sku,
      name,
      price,
      currency,
      planType,
      sellingTypes,
      discountCode,
      questionQuota,
    });

    const {
      payment: { orderNumber },
    } = yield call(apiCheckoutBuildPending, buildPendingData);
    // Line Pay only accepts encoded parameters
    let requestData = {
      ...commonData,
      invoiceInfo,
      orderNumber,
      confirmUrl: LINE_PAY_CONFIRM_WEBHOOk,
      cancelUrl:
        window.origin +
        window.location.pathname +
        encodeURIComponent(window.location.hash),
    };

    localStorage.setItem(
      orderNumber,
      JSON.stringify({ discountCode, sellingTypes })
    );

    const response = yield call(apiRequestLinePay, requestData);
    yield put(actions.requestLinePaySuccess({ paymentUrl: response.data.web }));
  } catch (err) {
    const { error_code, message } = err;
    yield put(actions.requestLinePayFailure(message));
    yield put(
      showAlertBanner({
        message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield put(setHasSubscription(error_code === HAS_SUBSCRIPTION_PLAN));
  }
}

export function* checkoutLinePay(action) {
  const { orderNumber } = action.payload;
  const { discountCode, sellingTypes } =
    JSON.parse(localStorage.getItem(orderNumber)) || {};
  localStorage.removeItem(orderNumber);

  try {
    const response = yield call(apiCheckoutLinePay, { orderNumber });
    const {
      questionQuota,
      purchasedPackage: { id: planId, planType, price, name },
      payment: {
        paymentMethod: { sku = '', price: originPrice, currency },
      },
    } = response.saleItem;

    yield call(sendSuccessCheckoutEvents, {
      sku,
      name,
      price,
      planId,
      currency,
      planType,
      orderNumber,
      originPrice,
      sellingTypes,
      discountCode,
      questionQuota,
    });

    yield put(
      savePurchase({
        orderNumber,
      })
    );
    yield put(actions.checkoutLinePaySuccess());
    yield put(paymentReceipt());
  } catch (err) {
    const { message } = err;
    yield put(actions.checkoutLinePayFailure(message));
    yield put(
      showAlertBanner({
        message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield delay(2000);
    yield put(home());
  }
}

export default function*() {
  yield all([takeLatest(actions.REQUEST_LINE_PAY, requestLinePay)]);
  yield all([takeLatest(actions.CHECKOUT_LINE_PAY, checkoutLinePay)]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/checkoutLinePay.js